import React from 'react';
import { DownloadAnalysisTheme } from '../../../graphql/projects/mutations/projects/useDownloadAnalysisGq';

export interface ChartTitlesProps {
  title: string;
  subtitle: string;
  slideTheme: DownloadAnalysisTheme;
}

export const ChartTitles: React.FC<ChartTitlesProps> = ({ title, subtitle, slideTheme }) => {
  return (
    <>
      <div
        className={`
            text-center 
            font-bold
            text-[32px]
            pb-0.5
            text-voxel-blue-500
            uppercase
            ${slideTheme === 'voxel' ? 'font-voxel-charts' : 'font-pixel-charts'}
        `}
      >
        {title}
      </div>
      <div
        className={`
            text-center 
            font-medium
            ${subtitle?.length > 100 ? 'text-[20px]' : 'text-[24px]'}
            w-max-[720px]
            m-auto
            text-gray-500
            ${slideTheme === 'voxel' ? 'font-voxel-charts' : 'font-pixel-charts'}
        `}
      >
        {subtitle}
      </div>
    </>
  );
};

export default ChartTitles;
